import { enhancedApi } from '@store/generated/data-migration';

export type {
  EhrOrganizationSummary,
  EhrUploadResponse as EhrUpload,
  EhrUploadFile,
  EhrUploadFilesResponse,
  EhrUploadListResponse,
  PresignRawUploadItem as EhrUploadTarget,
} from '@store/generated/data-migration';

export const ehrApi = enhancedApi.enhanceEndpoints({
  addTagTypes: ['EhrUploads', 'EhrFiles', 'EhrSummaries'],
  endpoints: {
    listEhrUploads: { keepUnusedDataFor: 0, providesTags: ['EhrUploads'] },
    listEhrUploadFiles: { keepUnusedDataFor: 0, providesTags: ['EhrFiles'] },
    adminListEhrUploads: {
      keepUnusedDataFor: 0,
      providesTags: (_result, _error, arg) => [{ type: 'EhrUploads', id: arg.organizationId }],
    },
    adminListEhrUploadFiles: { keepUnusedDataFor: 0, providesTags: ['EhrFiles'] },
    refreshEhrUpload: { invalidatesTags: ['EhrUploads', 'EhrFiles'] },
  },
});

export const {
  useLazyListEhrUploadsQuery,
  useLazyListEhrUploadFilesQuery,
  useLazyAdminListEhrUploadFilesQuery: useLazyListAdminEhrUploadFilesQuery,
  useCreateEhrUploadMutation,
  useRefreshEhrUploadMutation,
  useAdminListEhrUploadsQuery: useListAdminEhrUploadsQuery,
  useAdminEhrUploadSummariesMutation: useReadEhrSummariesMutation,
} = ehrApi;
